import { Link, Outlet, useLocation, matchPath } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BreadCrumb from "../components/BreadCrumb";
import React, { useState } from 'react';
import { SidebarConfig } from "../common/Config";
import { useSelector } from "react-redux";
import { getSlugByLang } from "../common/Helper";

function SidebarLayout() {
    const [breadcrumbList, setBreadcrumbList] = useState([])
    const location = useLocation();
    const user = useSelector((state) => state.user);
    const userlang = getSlugByLang(user?.language);

    // const match = (path) => {
    //     return path ? !!matchPath({ path, end: true }, location.pathname) : false;
    // };
    const match = (path) => {

        if (location.pathname === ('/' + userlang + "/profile/bookings/past") && path === ('/' + userlang + "/profile/bookings/upcoming")) {
            return true;
        }
        return path ? !!matchPath({ path, end: true }, location.pathname) : false;
    };
    return (
        <>
            <Header />
            <section className="listProducts profileMainTabSec">
                <div className="container">
                    <div className="listProducts-part">
                        <div className="activityhead">
                            {/* <div className="backBox">
                                <Link to="/"><i className="fa-solid fa-chevron-left"></i> Go home</Link>
                            </div> */}
                            <BreadCrumb list={breadcrumbList} />
                        </div>
                        <div className="mainListProducts">
                            <div className="row">
                                <div className="col-lg-3">
                                    <div className="leftTabcustom backLayerCom">
                                        <div className="tabBtnbox">
                                            <ul>
                                                {
                                                    SidebarConfig.map((val, key) => {

                                                        return (
                                                            <li key={key}>
                                                                <Link className={match('/' + userlang + val.path) ? "custombtn active" : "custombtn"} to={'/' + userlang + val.path}>
                                                                    {/* <i className={match(val.path) ? val.icon + "-fill" : val.icon}></i> */}
                                                                    {match('/' + userlang + val.path) ? val.activeIcon : val.icon}
                                                                    {val.title}
                                                                    <i className="fa-solid fa-chevron-right"></i>
                                                                </Link>
                                                            </li>
                                                        )
                                                    })
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-9">
                                    <Outlet context={[setBreadcrumbList]} />
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
}
export default SidebarLayout;